import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Qué es exactamente Desintoxica tu Mente en 21 Días?',
    a: 'Es una guía práctica de 21 días organizada en 3 fases progresivas. Trabaja hábitos de bienestar relacionados con sobrecarga mental, respiración, sueño, movimiento, hábitos digitales, nutrición, pensamientos y límites personales.'
  }, {
    q: '¿Cuánto tiempo debo dedicarle cada día?',
    a: 'Depende del ejercicio del día. Muchas prácticas duran entre 5 y 20 minutos. La idea no es añadir otra obligación pesada, sino incorporar pequeñas acciones de forma progresiva.'
  }, {
    q: '¿Es solamente un detox digital?',
    a: 'No. Reducir el ruido digital es solo una parte de la guía. También incluye respiración, journaling, movimiento, sueño, nutrición, herramientas cognitivas, límites y conexión personal.'
  }, {
    q: '¿Qué pasa si me salto un día o no puedo seguirlo perfectamente?',
    a: 'No necesitas hacerlo de forma perfecta. La guía incluye un protocolo de reconexión y recuerda que 21 días son un punto de partida, no una meta rígida. Puedes retomar el proceso y continuar.'
  }, {
    q: '¿Cómo recibo el eBook?',
    a: 'La compra se realiza de forma segura a través de Hotmart. Una vez aprobado el pago, recibirás por correo electrónico el acceso inmediato al eBook digital en PDF para comenzar con el Día 1.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-light-sage" data-id="element-15" data-mp="2odwz9tx7avqz">
      <div className="max-w-3xl mx-auto px-6" data-id="element-16" data-mp="2jeu2sxvadxum">
        <FadeIn data-id="element-17" data-mp="2jg550t932xjm">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-12" data-id="element-18" data-mp="2jdiymwxxio2z">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-19" data-mp="p2vsesl8qvx5">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-20" data-mp="2p4dezsoqg70w" data-mpi={index}>
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-21" data-mp="2p5x13zx2lcal">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-22" data-mp="2z18gmkgaynje">
                  <span className="font-serif font-bold text-lg text-brand-charcoal pr-4" data-id="element-23" data-mp="380lo57kv921h">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-forest transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-24" data-mp="3htanx5720rgz" />
                </button>

                <AnimatePresence data-id="element-25" data-mp="3quqzhg9luzms">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-26" data-mp="3vsshryz7iux7">
                      <div className="px-6 pb-5 text-brand-gray leading-relaxed" data-id="element-27" data-mp="1yumj4clzm8yx">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}